<script setup lang="ts">
import { useI18n } from "vue-i18n";

defineEmits<{ subscribe: []; tryAnotherNumber: []; contactSupport: [] }>();

const { t } = useI18n();
</script>

<template>
  <section class="paywall gate-card" aria-live="polite">
    <h2 class="paywall__headline">{{ t("paywall.headline") }}</h2>
    <p class="paywall__body">{{ t("paywall.body") }}</p>

    <button type="button" class="gate-button paywall__cta" @click="$emit('subscribe')">
      {{ t("paywall.cta") }}
    </button>

    <button
      type="button"
      class="gate-button gate-button--ghost paywall__secondary"
      @click="$emit('tryAnotherNumber')"
    >
      {{ t("paywall.tryAnother") }}
    </button>

    <hr class="paywall__separator" />

    <button type="button" class="paywall__link" @click="$emit('contactSupport')">
      {{ t("paywall.contactSupport") }}
    </button>
  </section>
</template>

<style scoped>
.paywall {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  text-align: left;
}

.paywall__headline {
  font-size: var(--font-size-2xl);
  font-weight: 700;
  color: var(--color-text);
  letter-spacing: -0.01em;
  line-height: 1.15;
}

.paywall__body {
  font-size: var(--font-size-md);
  color: var(--color-text-secondary);
  line-height: 1.5;
}

.paywall__cta {
  margin-top: var(--space-2);
}

.paywall__separator {
  width: 100%;
  height: 1px;
  border: 0;
  background-color: var(--color-border);
  margin: 0;
}

.paywall__link {
  align-self: center;
  background: none;
  border: none;
  padding: var(--space-2) var(--space-4);
  font-size: var(--font-size-sm);
  color: var(--color-primary-hover);
  cursor: pointer;
  font-weight: 500;
  border-radius: var(--radius);
  transition:
    background-color var(--transition-fast),
    transform var(--transition-fast);
}

.paywall__link:hover {
  background-color: var(--color-bg-tint);
}

.paywall__link:focus-visible {
  outline: 2px solid var(--color-primary-hover);
  outline-offset: 2px;
}

.paywall__link:active {
  transform: scale(0.98);
}
</style>
